module.exports = __webpack_public_path__ + "bs.cbc10545.svg";